// extracted by mini-css-extract-plugin
export default {"checkbox":"AppCheckbox_checkbox__bRYho","notActive":"AppCheckbox_notActive__yJklr","disabled":"AppCheckbox_disabled__nEjHe","admin":"AppCheckbox_admin__+3T2j"};